import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MenuItem, UserSpaceMenuService } from '../../_services/app/user-space-menu.service';
import { AuthService } from '../../_services/api/auth.service';
import { SpaceLayoutComponent } from '../../pages-struct/space-layout/space-layout.component';

@Component({
  selector: 'app-member-layout',
  standalone: true,
  imports: [RouterOutlet, SpaceLayoutComponent],
  templateUrl: './member-layout.component.html',
  styleUrl: './member-layout.component.html'
})
export class MemberLayoutComponent implements OnInit {
  userAvatar: string = 'assets/images/user-default.png';
  userFirstName: string = '';
  menuItems: MenuItem[] = [];

  constructor(
    private menuService: UserSpaceMenuService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.menuItems = this.menuService.getMemberMenu();
    this.loadUserData();
  }

  private loadUserData() {
    const user = this.authService.getUserInfo();
    if (user) {
      this.userFirstName = user.firstName;
      this.userAvatar = user.avatar || this.userAvatar;
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}